<template>
  <div class="home">
    <!-- 弹出框 -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
      <div class="dialog_tit" slot="title">学习说明</div>
      <div class="dialog_desc">
        1、在线课程学习总成绩占比{{ rates.studyRate }}%
        <br />
        2、课程练习总成绩占比{{ rates.practiceRate }}%
        <br />
        3、课程考试总成绩占比{{ rates.examRate }}%
        <br />
        4、课程答疑笔记总成绩占比{{ rates.answerRate }}%
        <br />
        <div>
          根据每门课程的总学分不同，按照学习情况，实时转化成学分。
          <br />
          每门课程总成绩达到{{ popup.rate }}及以上即为合格 eg：{{
            popup.title
          }}线上成绩总分{{ popup.total }}分，
          <br />
          （在线课程学习+课程练习+课程考试+答疑笔记）≥{{
            popup.rate
          }}，合格。否则不合格
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div @click="centerDialogVisible = false">确定</div>
      </span>
    </el-dialog>

    <div class="content_box">
      <!-- 公告 -->
      <el-row :gutter="32">
        <el-col :xs="24" :sm="24" :lg="8">
          <div class="personal_tit">个人信息</div>
          <div class="personal_body">
            <div class="personal_body_top">
              <div class="per_bd_left">
                <div class="txImg">
                  <img src="../assets/img/home/img8.png" style="width: 105px; height: 105px;" />
                  <div v-if="parseInt(userInfo.sex) == 1">
                    <div class="name">{{ userInfo.username }}</div>
                    <img
                            class="gender"
                            src="../assets/img/home/icon-4-1.png"
                            style="width: 105px; height: 105px;"
                    />
                  </div>
                  <div v-else>
                    <div class="name">{{ userInfo.username }}</div>
                    <img
                            class="gender"
                            src="../assets/img/home/icon-4.png"
                            style="width: 105px; height: 105px;"
                    />
                  </div>
                </div>
                <div class="info_box">
                  <div>账号：{{ userInfo.username }}</div>
                  <div>专业：{{ userInfo.majorName }}</div>
                  <div>班级：{{ userInfo.clbumName }}</div>
                  <div>学号：{{ userInfo.stuNum }}</div>
                </div>
              </div>
            </div>
            <div class="info_tips">
              毕业要求：各门课及格分值为65%，五个学期不挂科即为合格 准许毕业~
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">

        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">

        </el-col>
      </el-row>

      <Msg :lists="lists"></Msg>
            <!-- 个人信息 -->
      <div class="personal_info">
       <!-- <div class="personal_left">
          <div class="personal_tit">个人信息</div>
          <div class="personal_body">
            <div class="personal_body_top">
              <div class="per_bd_left">
                <div class="txImg">
                  <img src="../assets/img/home/img8.png" alt />
                  <div v-if="parseInt(userInfo.sex) == 1">
                    <div class="name">{{ userInfo.username }}</div>
                    <img
                      class="gender"
                      src="../assets/img/home/icon-4-1.png"
                      alt
                    />
                  </div>
                  <div v-else>
                    <div class="name">{{ userInfo.username }}</div>
                    <img
                      class="gender"
                      src="../assets/img/home/icon-4.png"
                      alt
                    />
                  </div>
                </div>
                <div class="info_box">
                  <div>账号：{{ userInfo.username }}</div>
                  <div>专业：{{ userInfo.majorName }}</div>
                  <div>班级：{{ userInfo.clbumName }}</div>
                  <div>学号：{{ userInfo.stuNum }}</div>
                </div>
              </div>
            </div>
            <div class="info_tips">
              毕业要求：各门课及格分值为65%，五个学期不挂科即为合格 准许毕业~
            </div>
          </div>
        </div>-->
        <div class="personal_right">
          <div class="nowTerm">
            <div>
              当前学期：{{ Now.name }}（{{
                (Now.beginTime * 1000) | dateFormat
              }}-{{ (Now.endTime * 1000) | dateFormat }}）
            </div>
            <div class="learnState" @click="centerDialogVisible = true">
              <div>学习说明</div>
              <img src="../assets/img/home/icon-5.png" alt />
            </div>
          </div>
          <div id="myChart" :style="{ width: '600px', height: '400px' }"></div>
        </div>
      </div>
      <!-- 教学计划 -->
      <div class="plan">
        <div class="plan_top">
          <div>教学计划</div>
          <div
            :class="{ active: more == 0 }"
            @mouseenter="more = 0"
            @mouseleave="more = -1"
          >
            <!-- 查看更多 -->
          </div>
        </div>
        <div class="plan_body">
          <!-- tabs切换 -->
          <div class="plan_tabs">
            <div
              class="tabsitem"
              v-for="(item, index) in semesterList"
              :key="index"
              :class="{ active2: active2 == index }"
              @click="changeTabs(index)"
            >
              <div>
                {{ item.name }}
                <span v-if="item.have_in_hand == 2">（已结束）</span>
                <span v-if="item.have_in_hand == 1">（当前学期）</span>
                <!-- <span v-if="item.have_in_hand == 0">（未开始）</span> -->
                <img
                  v-if="active2 == index"
                  src="../assets/img/home/title-2.png"
                  alt
                />
                <img v-else src="../assets/img/home/title-3.png" alt />
              </div>
              <div :class="{ active: active2 == index }">
                {{ (item.beginTime * 1000) | dateFormat }}-{{
                  (item.endTime * 1000) | dateFormat
                }}
              </div>
            </div>
          </div>
          <div class="plan_list">
            <div
              class="list_box"
              v-for="(item3, index3) in planList[nowIndex]"
              :key="index3"
            >
              <img class="listImg" :src="imgUrl + item3.cover_img" alt />
              <div class="list_right">
                <div class="list_tit">{{ item3.name }}</div>
                <div class="xuefen">
                  学分：{{ totalScore}}  /{{ item3.score }}
                </div>
                <div v-if="item3.is_pass == 1 && item3.btn != 0" class="status">
                  <img src="../assets/img/home/icon-6.png" alt />
                  <div>已通过</div>
                </div>
                <div
                  v-if="item3.is_pass == 0 && item3.btn != 0"
                  class="status status2"
                >
                  <img src="../assets/img/home/icon-7.png" alt />
                  <div>未通过</div>
                </div>
                <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                  已结束
                </div>
                <div v-if="item3.btn == 0" class="list_btn list_btn_n1">
                  未开始
                </div>
                <div
                  v-if="item3.is_pass == 1 && item3.btn == 1"
                  class="list_btn"
                >
                  已完成
                </div>
                <div
                  v-if="item3.is_pass == 0 && item3.btn == 1"
                  class="list_btn2"
                  @click="toVideo(item3.id)"
                  :class="{ current: current == index3 }"
                  @mouseenter="current = index3"
                  @mouseleave="current = -1"
                >
                  开始学习
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 公告通知 -->
      <div class="msg_box">
        <div class="plan_top">
          <div>公告通知</div>
          <div
            :class="{ active: more == 1 }"
            @mouseenter="more = 1"
            @mouseleave="more = -1"
          >
            <!-- 查看更多 -->
          </div>
        </div>
        <div class="msg_body">
          <div class="msg_left">
            <img :src="imgUrl + notice_img" alt />
          </div>
          <div class="msg_right">
            <div
              @click="toMag(item.id)"
              class="rt_list"
              v-for="(item, index) in noticeList"
              :key="index"
            >
              <div>
                <img src="../assets/img/home/icon-3.png" alt />
                <div>{{ item.title }}</div>
              </div>
              <div class="time">{{ (item.addtime * 1000) | dateFormat }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHome,uploadVideo} from "../assets/js/api.js";
import store from "store";
import Msg from "@/components/msg.vue";
import Bus from "../bus.js";

export default {
  name: "Home",
  components: {
    Msg,
  },
  data() {
    return {
        fileList:[],
      imgUrl: "./assets/img/home/bg-1.png",
      // 用户信息
      userInfo: "",
      // 学校信息
      schoolInfo: "",
      // 教学计划
      semesterList: "",
      // 当前学期
      Now: "",
      nowIndex: 0,
      centerDialogVisible: false,
      more: -1,
      active2: 0,
      current: -1,
      Etitle: "当前学期课程：",
      titNum: 2 / 5,
      lists: [], //轮播中的文字
      planList: [],
      // 公告列表
      noticeList: [],
      notice_img: "",
      // echarts数据
      across: [],
      information: [],
        titles:"",
      // 学习说明 弹框数据
      popup: {
        title: "",
        total: 0,
        rate: 0,
      },
        rates:"",
        screenWidth:document.body.clientWidth
    };
  },
  mounted() {

    const that =this
    window.onresize =() =>{
        return (() =>{
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
        })
    }
    this.getHome();
    window.scroll(0, 0);
  },

    watch:{
        screenWidth(val){
            if(!this.timer){
                this.screenWidth = val
                this.timer = true
                let that = this
                setTimeOut(function(){
                    that.timer= false
                },400)
            }
        }
    },
  methods: {
      //
    getHome() {
      getHome(window.localStorage.getItem("siteId"),window.localStorage.getItem("info")).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.userInfo = res.data;
          this.schoolInfo = res.data.site;
          store.set("bannerImg", res.data.site.frontLogo);
          this.semesterList = res.data.terms;
          this.noticeList = res.data.notices;
            if (!this.noticeList == undefined || !this.noticeList.length <= 0){
                this.lists = res.data.notices[0].title;
            } else {
                this.lists = "暂无公告！";
            }

          if (this.noticeList.length > 6) {
            this.noticeList.length = 6;

          }

          let semester = this.semesterList[0].myClasss[0].rates;
          this.notice_img = res.data.notice_img;

          // 学习说明
          this.popup.title = this.semesterList[0].myClasss[0].name;
          this.popup.total = this.semesterList[0].myClasss[0].score;
          this.popup.rate = this.semesterList[0].myClasss[0].rate
            this.rates = this.semesterList[0].myClasss[0].rates
            // (semester.total_score - 0) * ((this.semesterList[0].myClasss[0].rate - 0) / 100);
          // console.log(this.semesterList);
          // 学习
          this.semesterList.forEach((item) => {
            if (item.have_in_hand == 2) {
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "2");
              });
            }
            if (item.have_in_hand == 1) {
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "1");
              });
            }
            if (item.have_in_hand == 0) {
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "0");
              });
            }
          });
          this.semesterList.map((x) => {
              console.log(x)
            this.planList.push(x.myClasss);
            if (x.have_in_hand == 1) {
              this.Now = x;
              x.myClasss.map((item) => {
                this.across.push(item.name);
                this.information.push(item.rate);
              });
            }
            this.drawLine();
          });

          Bus.$emit("schoolInfo", this.schoolInfo);
          Bus.$emit("userInfo", this.userInfo);
        }
      });
    },
    changeTabs(i) {
      this.active2 = i;
      this.nowIndex = i;
    },
    //跳转到学习页面
    toVideo(id) {
      console.log(id);
      // 继续学习
      this.$router.push({
        path: "/video",
        query: {
          id: id,
        },
      });
    },
    // 跳转到消息中心
    toMag(id) {
      this.$router.push({
        path: "/msgDetail",
        query: {
          id: id,
        },
      });
    },
    drawLine() {
      let t = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "当前学期课程：",
          textStyle: {
            color: "#333",
            fontSize: "18",
            fontWeight: "normal",
          },
        },
        tooltip: {
          // 禁止悬停框
          show: false,
        },
        xAxis: {
          data: t.across,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
              fontSize: "14",
            },
            formatter: function (value, index) {
              let v = value.substring(0, 3) + "...";
              return value.length > 3 ? v : value;
            },
          },
          axisTick: {
            show: false, //不显示坐标轴刻度线
          },
          axisLine: {
            lineStyle: {
              color: "#CBCBCB", // x坐标轴的轴线颜色 //这里是坐标轴的宽度,可以去掉
            },
          },
        },
        yAxis: {
          axisTick: {
            show: false, //不显示坐标轴刻度线
          },
          // axisLine: {
          //   show: false, //不显示坐标轴线
          // },
          axisLabel: {
            show: false, //不显示坐标轴上的文字
          },

          splitLine: {
            show: false, //不显示网格线
          },
          axisLine: {
            lineStyle: {
              color: "#CBCBCB", // x坐标轴的轴线颜色 //这里是坐标轴的宽度,可以去掉
            },
          },
        },
        series: [
          {
            // name: "销量",
            type: "bar",
            data: t.information,
            barWidth: 38,
            itemStyle: {
              normal: {
                color: new t.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(79, 163, 255, 1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(79, 199, 255, 1)",
                  },
                ]),
                // barBorderColor: "#E7E941", // 柱条边线
                // barBorderRadius: 0, // 柱条边线圆角，单位px，默认为0
                // barBorderWidth: 1, // 柱条边线线宽，单位px，默认为1
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#333",
                    fontSize: 20,
                  },
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>
<style lang="less" scoped>
.plan_tabs::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}
.plan_tabs::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.plan_tabs::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.plan_tabs::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.plan_tabs::-webkit-scrollbar-corner {
  background: #179a16;
}
.home {
  margin-top: 60px !important;
}
.active {
  color: #4490e6 !important;
}
.current {
  background-color: #4fa3ff;
  color: #fff !important;
}
/deep/ .el-dialog {
  width: 740px;
  min-width: 600px;
  // height: 500px;
  min-height: 500px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
}
/deep/ .el-dialog__header {
  padding: 0;
}
.dialog_tit {
  width: 100%;
  height: 74px;
  line-height: 74px;
  background-color: #438fe5;
  font-size: 30px;
  color: #ffffff;
}
.dialog_desc {
  line-height: 2.5;
}
.dialog-footer {
  div {
    width: 180px;
    height: 50px;
    background: #438fe5;
    box-shadow: 3px 2px 0px 0px #004ea8;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 20px;
    margin: 0 auto;
    cursor: pointer;
  }
}
.banner_box {
  width: 100%;
  height: 500px;
  // margin-top: 60px;
  .banner_img {
    width: 100%;
    height: 500px;
  }
}
.content_box {
  width: 1200px;
  margin: 0 auto;
  .intro {
    position: relative;
    height: 465px;
    // display: flex;
    .intro_left {
      position: absolute;
      z-index: 1;
      top: 6%;
      left: 0px;
      width: 674px;
      height: 411px;
      background-color: #fff;
      padding: 25px 30px;
      box-sizing: border-box;
      .intro_name {
        width: 220px;
        height: 60px;
        background: url("../assets/img/home/title-1.png") no-repeat;
        background-size: 100%;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      .intro_desc {
        font-size: 14px;
        color: #333;
        line-height: 2;
        p {
          text-indent: 2em;
        }
      }
    }
    .intro_right {
      position: absolute;
      right: 0;
      img {
        width: 700px;
        height: 465px;
      }
    }
  }
  .personal_info {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .personal_left {
      width: 603px;
      height: 425px;
      background: url("../assets/img/home/bg-1.png") no-repeat;
      background-size: 100%;
      .personal_tit {
        width: 100%;
        height: 50px;
        background: url("../assets/img/home/bg-2.png") no-repeat;
        background-size: 100%;
        font-size: 20px;
        color: #4fa3ff;
        line-height: 50px;
        padding-left: 25px;
        box-sizing: border-box;
      }
      .personal_body {
        padding: 0 40px;
        box-sizing: border-box;
        .personal_body_top {
          margin: 50px 0;
          .per_bd_left {
            display: flex;
            color: #fff;
            font-size: 16px;
            .txImg {
              width: 106px;
              height: 106px;
              margin-right: 25px;
              .name {
                font-size: 18px;
              }
              .gender {
                width: 16px;
                height: 16px;
                margin-left: 5px;
              }
              > div {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 5px;
              }
            }
            .info_box {
              line-height: 2.5;
            }
          }
        }
        .info_tips {
          font-size: 16px;
          color: #fff;
        }
        .per_sign {
          width: 523px;
          height: 43px;
          background: #ffffff;
          border-radius: 21px;
          font-size: 16px;
          color: #4fa2ff;
          text-align: left;
          line-height: 43px;
          padding: 0 25px;
          box-sizing: border-box;
          margin-top: 20px;
        }
      }
    }
    .personal_right {
      width: 587px;
      height: 425px;
      // background-color: pink;
      padding: 15px;
      box-sizing: border-box;
      .nowTerm {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .learnState {
          cursor: pointer;
        }
        div:nth-child(1) {
          font-size: 20px;
          color: #333;
        }
        div:nth-child(2) {
          font-size: 18px;
          display: flex;
          align-items: center;
          div {
            color: #438fe5 !important;
          }
          img {
            width: 18px;
            height: 18px;
            margin-left: 8px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .plan_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    margin: 50px 0;
    padding-left: 13px;
    box-sizing: border-box;
    border-left: 5px solid #029aff;
    div:nth-child(1) {
      font-size: 20px;
      color: #333;
    }
    div:nth-child(2) {
      font-size: 16px;
      color: #999;
      cursor: pointer;
    }
  }
  .plan {
    .plan_body {
      .plan_tabs {
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        // overflow-x: scroll;
        // overflow: auto;
        .tabsitem {
          // width: 220px;
          margin-bottom: 30px;
          margin-right: 30px;
          div:nth-child(1) {
            position: relative;
            width: 216px;
            // padding: 0 38px;
            // box-sizing: border-box;
            height: 50px;
            font-size: 18px;
            color: #fff;
            text-align: center;
            line-height: 50px;
            // background: url("../assets/img/home/title-3.png") no-repeat;
            // background-size: 100%;
            cursor: pointer;
            border-radius: 10px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              bottom: 0;
              z-index: -1;
            }
          }
          div:nth-child(2) {
            font-size: 14px;
            color: #666666;
            text-align: center;
            margin-top: 5px;
          }
        }
        .tabsitem:nth-child(5n){
          margin-right: 0;
        }
      }
      .plan_list {
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        margin-top: 50px;
        .list_box {
          display: flex;
          margin-bottom: 70px;
          // margin-right: 95px;
          margin-right: 45px;
          .listImg {
            // width: 235px;
            width: 210px;
            height: 122px;
            margin-right: 20px;
          }
          .list_right {
            // width: 168px;
            display: flex;
            flex-direction: column;
            height: 122px;
            justify-content: space-around;
            .list_tit {
              font-size: 20px;
              color: #333;
              margin-bottom: 15px;
            }
            .xuefen {
              font-size: 14px;
              color: #999999;
            }
            .status {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #02cb73;
              img {
                width: 16px;
                height: 16px;
                margin: 8px 5px 8px 0;
              }
            }
            .status2 {
              color: #fe0000;
            }
            .list_btn {
              width: 80px;
              height: 28px;
              background: #02cb73;
              border-radius: 14px;
              text-align: center;
              line-height: 28px;
              color: #fff;
              font-size: 12px;
            }
            .list_btn2 {
              width: 80px;
              height: 28px;
              border: 1px solid #4fa3ff;
              border-radius: 14px;
              text-align: center;
              line-height: 28px;
              color: #4fa3ff;
              font-size: 12px;
              cursor: pointer;
            }
            .list_btn_n {
              background: #999;
            }
            .list_btn_n1 {
              background: #cccccc;
            }
          }
        }
        .list_box:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .msg_box {
    .msg_body {
      display: flex;
      margin-bottom: 60px;
      .msg_left {
        width: 454px;
        height: 284px;
        // background-color: #0199ff;
        margin-right: 35px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .msg_right {
        width: 710px;
        .rt_list {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          font-size: 18px;
          height: 50px;
          color: #333;
          > div:nth-child(1) {
            display: flex;
            cursor: pointer;
          }
          img {
            width: 27px;
            height: 23px;
            margin-right: 10px;
          }
          .time {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
